import { djs, type Dayjs } from '@duke-hq/djs';
import { RTO_TIMEZONE } from './timezones';

export const STUDENT_MINIMUM_AGE = 10;
export const STUDENT_MAXIMUM_AGE = 70;
export const GUARDIAN_CONSENT_AGE_LIMIT = 17;

export function isGuardianConsentOutstanding(enrolment: {
  guardianConsentRequiredAt: Date | null;
  guardianConsentResolvedAt: Date | null;
}): boolean {
  return enrolment.guardianConsentRequiredAt != null && enrolment.guardianConsentResolvedAt == null;
}

/** The earliest and latest birth dates an enrolling student can have today, as `YYYY-MM-DD`. */
export function studentBirthDateRange(): { earliest: string; latest: string } {
  const today = djs();
  return {
    earliest: today.subtract(STUDENT_MAXIMUM_AGE, 'year').format('YYYY-MM-DD'),
    latest: today.subtract(STUDENT_MINIMUM_AGE, 'year').format('YYYY-MM-DD'),
  };
}

export function requiresGuardianConsent(
  dateOfBirth: Date | undefined | null,
  enrolledAt: Date,
): boolean {
  if (!(dateOfBirth instanceof Date)) {
    return false;
  }

  const birthDay = djs.utc(dateOfBirth);
  const enrolmentDay = djs(enrolledAt).tz(RTO_TIMEZONE);
  return completedYears(birthDay, enrolmentDay) < GUARDIAN_CONSENT_AGE_LIMIT;
}

function completedYears(birthDay: Dayjs, onDay: Dayjs): number {
  const yearsByCalendar = onDay.year() - birthDay.year();
  const birthdayStillAhead = onDay.format('MM-DD') < birthDay.format('MM-DD');
  return birthdayStillAhead ? yearsByCalendar - 1 : yearsByCalendar;
}
